<template>
  <el-popover
    placement="bottom"
    width="226px"
    trigger="click"
    v-model="computedVisible"
  >
    <div class="popover-content">
      <div class="popover-item-box" v-if="hasContactInfo">
        <div class="header">
          <p>{{ contractMap.name }}</p>
          <p v-if="contractMap.positionSelect!=0">{{ contractMap.positionSelectStr }}</p>
          <p v-else>{{contractMap.position}}</p>
        </div>
        <div class="popover-concat">
          <p class="concat-phone">
            <i class="icon-Telephone iconfont mr16"></i>
            <span>{{contractMap.codeTel}} &nbsp;{{ contractMap.tel }}</span>
          </p>
          <p class="concat-phone">
            <i class="iconfont icon-mobile mr16"></i>
            <span>{{contractMap.codeTel}} &nbsp;{{ contractMap.mobile }}</span>
          </p>
        </div>
      </div>
      <div class="empty-tc" v-else>暂无联系方式</div>
    </div>
    <slot name="reference" slot="reference"></slot>
    <!-- <span class="value mock-button" slot="reference">联系采购商</span> -->
  </el-popover>
</template>

<script>
import { concat } from 'lodash';

export default {
  name: 'contact-popover',
  props: {
    contractMap: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    computedVisible: {
      get() {
        return this.visible
      },
      set(newVal) {
        this.$emit('update:visible', newVal)
      },
    },
    hasContactInfo() {
      return Object.keys(this.contractMap).length > 0
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    handleClickOutside(event) {
      const popover = document.querySelector('.contact-popover')
      const reference = this.$el.querySelector('[slot="reference"]')

      if (
        this.computedVisible &&
        !popover?.contains(event.target) &&
        !reference?.contains(event.target)
      ) {
        this.computedVisible = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
/* SCSS or CSS here */
.popover-content {
  width: 210px;
  height: 124px;
  flex-shrink: 0;
  border-radius: 4px;
  background: #fbfbfb;
  .popover-item-box {
    padding: 16px;
    .header {
      display: flex;
      align-items: center;
      gap: 8px;
      p:nth-child(1) {
        color: #333333;
        font-family: SourceHanSansCN-Bold;
        font-size: 14px;
        // font-weight: 700;
        line-height: 22px;
      }
      p:nth-child(2) {
        color: #999999;
        font-family: SourceHanSansCN-Regular;
        font-size: 12px;
        line-height: 24px;
      }
    }
    .popover-concat {
      margin-top: 18px;
      .concat-phone {
        margin-bottom: 4px;
        color: #333333;
        font-family: SourceHanSansCN-Regular;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
      }
    }
  }
}
.mr16 {
  margin-right: 16px;
}
.empty-tc {
  text-align: center;
  line-height: 124px;
}
</style>
